export default __webpack_public_path__ + "static/media/defectSample.0fdc5c3c.png";